<nb-card class="module-menu-card" data-tour="module-side-panel">
  <nb-card-header>
    <button nbButton ghost size="small" class="close-btn" (click)="onClose()">
      <nb-icon icon="close-outline"></nb-icon>
    </button>
    <span class="header-title">{{ isEditMode ? 'Modifier le module' : 'Enregistrer en tant que module' }}</span>
  </nb-card-header>
  
  <nb-card-body>
    <form [formGroup]="form">
      <!-- Preview Section -->
      <div class="preview-section" data-tour="module-preview" [nbSpinner]="isLoading" nbSpinnerStatus="info" nbSpinnerSize="large" nbSpinnerMessage="">
        <div class="image-placeholder" *ngIf="!screenshotUrl && !isLoading">
          <!-- Optional: Default icon or text -->
        </div>
        <img *ngIf="screenshotUrl && !isLoading" [src]="screenshotUrl" alt="Module preview" class="module-preview-img">
      </div>

      <!-- Form Fields -->
      <div class="form-group">
        <label for="moduleName">Nom du module</label>
        <div class="input-wrapper">
          <input nbInput fullWidth id="moduleName" formControlName="name" placeholder="" data-tour="module-name-input">
          <span class="required-asterisk">*</span>
        </div>
      </div>

      <div class="form-group">
        <label for="moduleDescription">Description</label>
        <textarea nbInput fullWidth id="moduleDescription" formControlName="description" rows="3"
          placeholder="Description : décrivez ce module en 500 caractères maximum." data-tour="module-description-input"></textarea>
      </div>

      <div class="form-group" data-tour="module-panel-tags">
        <label for="moduleTags">Balises</label>
        <nb-tag-list (tagRemove)="onTagRemove($event.text)">
          <nb-tag *ngFor="let tag of selectedTags" [text]="tag" removable></nb-tag>
          <input type="text" nbTagInput (tagAdd)="onTagAdd($event)" [nbAutocomplete]="auto" #tagInput fullWidth placeholder="Saisir des balises puis appuyer sur entrée...">
        </nb-tag-list>
        
        <nb-autocomplete #auto (selectedChange)="onTagSelectedWithInput($event, tagInput)">
          <nb-option *ngFor="let option of filteredAvailableTags" [value]="option">
            {{ option.value || option }}
          </nb-option>
        </nb-autocomplete>
        <small class="tags-hint">Appuyez sur Entrée après chaque balise pour qu'elle soit prise en compte.</small>
      </div>
    </form>
  </nb-card-body>
  
  <nb-card-footer>
    <div class="footer-actions">
      <button *ngIf="isEditMode && !hideEditorActions" nbButton status="basic" fullWidth (click)="onOpenInEditor()" data-tour="module-open-editor">
        Ouvrir dans l'éditeur
      </button>
      <button nbButton status="info" fullWidth (click)="onSave()" data-tour="module-save-btn">
        <nb-icon [icon]="isEditMode ? 'refresh-outline' : 'cloud-upload-outline'"></nb-icon> {{ isEditMode ? 'Mettre à jour' : 'Enregistrer' }}
      </button>
      <button *ngIf="isEditMode && !hideEditorActions" nbButton status="danger" fullWidth (click)="onDelete()">
        <nb-icon icon="trash-2-outline"></nb-icon> Supprimer
      </button>
    </div>
  </nb-card-footer>
</nb-card>
